const dateTime = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** Data e ora in formato italiano (`30/09/2026, 12:05`), comune alle sezioni delle Impostazioni. */
export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}
